import React, { useEffect, useState } from 'react';
import { CloudCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { api } from './api';
import { usePlatform } from './PlatformContext';
import './streaks.css';

export const EndlessAccountRecord = ({ prefix = 'personal-bests' }) => {
  const { user, scope, version } = usePlatform();
  const [snapshot, setSnapshot] = useState(null), [error, setError] = useState(''), [retry, setRetry] = useState(0);
  const key = `${user?.id}:${scope}`;
  useEffect(() => {
    let alive = true;
    setSnapshot(null); setError('');
    if (!user?.alias_confirmed || !scope) return;
    api('/endless/records').then(result => {
      if (!alive) return;
      if (result.user_id !== user.id || result.scope !== scope) throw new Error('Account changed.');
      setSnapshot({ key, ...result });
    }).catch(() => { if (alive) setError('Your account record is unavailable. Device records are kept separately.'); });
    return () => { alive = false; };
  }, [key, user?.id, user?.alias_confirmed, scope, version, retry]);
  if (!user?.alias_confirmed) return null;
  const record = snapshot?.key === key ? snapshot : null;
  return <section className="ps-identity endless-account-record" data-testid={`${prefix}-account-endless-record`}>
    <h3 data-testid={`${prefix}-account-endless-heading`}><CloudCheck size={16} aria-hidden="true"/> ACCOUNT · ENDLESS</h3>
    {error ? <div className="streak-status" data-testid={`${prefix}-account-endless-error`}><p>{error}</p><Button variant="ghost" data-testid={`${prefix}-account-endless-retry`} onClick={() => setRetry(value => value + 1)}>Try again</Button></div> : !record ? <Skeleton className="h-12 w-full" data-testid={`${prefix}-account-endless-loading`}/> : <>
      <dl className="streak-account-metric"><dt data-testid={`${prefix}-account-endless-label`}>Longest Endless streak</dt><dd data-testid={`${prefix}-account-endless-value`}>{record.longest_endless_streak_shapes} {record.longest_endless_streak_shapes === 1 ? 'shape' : 'shapes'}</dd></dl>
      <p data-testid={`${prefix}-account-endless-note`}>{record.total_rounds ? 'All-time best from synced shapes. Available on every device.' : 'No synced shapes yet. Complete a shape to start your account record.'}</p>
    </>}
  </section>;
};
